import useCasesStore from '../store/useCasesStore'
import useAppStore from '../store/useAppStore'
import useCrashStore from '../features/crash/store/useCrashStore'
import useDoubleStore from '../features/double/store/useDoubleStore'
import useWheel500Store from '../features/wheel500/store/useWheel500Store'
import useRoyaleStore from '../features/royale/store/useRoyaleStore'
import useBattleStore from '../features/battle/store/useBattleStore'
import { refreshUpdateBlockers, registerUpdateGuard } from './appUpdateService'

const flag = (value) => value === true || value === 1 || value === '1'
export const isRoundSnapshotUpdateBlocked = (state) => Boolean(!state.isModeDisabled && !state.activeRound
  || state.engine === 'node' && !state.isConnected)
export const isCrashUpdateBlocked = (state) => Boolean(state.isPlacingBet || state.isCashingOut
  || state.myBet && !flag((state.players?.get(String(state.myChatId)) || state.myBet).cashed) && state.phase !== 'busted'
  || state.pendingWinSkinChatIds?.has(String(state.myChatId)))
export const isRoundUpdateBlocked = (state, userId = null) => {
  const round = state.activeRound
  const ownBets = [...(round?.bets || []), ...(state.bets || [])].some((bet) => flag(bet.your_bet) || flag(bet.you)
    || userId != null && String(bet.chat_id) === String(userId))
    || (state.ownBetAcks || []).some((bet) => !round || String(bet.round_id) === String(round.id))
  return Boolean(state.isBetting || state.pendingBetIds?.length
    || ownBets && !['result', 'finished'].includes(round?.status))
}

export function watchGameUpdateSafety() {
  const guards = [
    [useCasesStore, (s) => s.isOpening || s.isOpeningMultiple],
    [useCrashStore, isCrashUpdateBlocked],
    [useDoubleStore, isRoundUpdateBlocked],
    [useWheel500Store, isRoundUpdateBlocked],
    [useRoyaleStore, isRoundUpdateBlocked],
    [useBattleStore, (s) => s.isCreating || [s.currentBattle, ...Object.values(s.battlesById), ...Object.values(s.battles)]
      .some((battle) => battle && flag(battle.you) && !['finished', 'cancelled'].includes(battle.status))]
  ]
  const release = registerUpdateGuard(() => {
    const user = useAppStore.getState().user
    const userId = user?.telegramid ?? user?.chat_id ?? user?.id ?? null
    return guards.some(([store, guard]) => guard(store.getState(), userId))
  })
  const subscriptions = [...guards.map(([store]) => store), useAppStore].map((store) => store.subscribe(refreshUpdateBlockers))
  return () => { subscriptions.forEach((unsubscribe) => unsubscribe()); release() }
}
